<oppgaveliste-kompakt [oppgaver]="oppgaver()"/>
